import { render, staticRenderFns } from "./NewDeductions.vue?vue&type=template&id=5174b614&scoped=true&"
var script = {}
import style0 from "./NewDeductions.vue?vue&type=style&index=0&id=5174b614&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5174b614",
  null
  
)

export default component.exports